'use client';

import {motion} from 'framer-motion';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';

const CompanyHero = () => {
  return (
    <motion.section
      className='company-hero'
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-icon-top'></div>
        <div className='bg-icon-left'></div>
        <div className='bg-icon-right'></div>
        <div className='bg-icon-mobile'></div>
        <h2 className='title'>
          We have been at the intersection of cybersecurity and innovation for
          <span className='highlight'> more than 30 years.</span>
        </h2>
        <p className='text'>
          In that time we have seen the impact of incidents and the cost and complexity of maintaining both infrastructure and security in a rapidly evolving world. We believe there is a
          <span className='highlight' style={{paddingLeft: '0.3em'}}>
            {' '}
            better way.
          </span>
        </p>
        <BookBtn text='Contact us' />
      </div>
    </motion.section>
  );
};

export default CompanyHero;

